import { applyCommand } from './commands/apply.js';
export function createHistory(limit = 200) {
    return { undo: [], redo: [], limit };
}
export function pushHistory(history, entry) {
    const undo = [...history.undo, entry];
    if (undo.length > history.limit)
        undo.shift();
    return { ...history, undo, redo: [] }; // qualquer ação nova invalida o redo
}
export function canUndo(history) {
    return history.undo.length > 0;
}
export function canRedo(history) {
    return history.redo.length > 0;
}
export function undo(seq, history, options) {
    const entry = history.undo[history.undo.length - 1];
    if (!entry)
        return null;
    const result = applyCommand(seq, entry.inverse, options);
    return {
        sequence: result.sequence,
        history: {
            ...history,
            undo: history.undo.slice(0, -1),
            redo: [...history.redo, entry],
        },
        entry,
    };
}
export function redo(seq, history, options) {
    const entry = history.redo[history.redo.length - 1];
    if (!entry)
        return null;
    const result = applyCommand(seq, entry.command, options);
    return {
        sequence: result.sequence,
        history: {
            ...history,
            redo: history.redo.slice(0, -1),
            undo: [...history.undo, { ...entry, inverse: result.inverse }],
        },
        entry,
    };
}
const LABELS = {
    ADD_TRACK: 'Adicionar track',
    REMOVE_TRACK: 'Remover track',
    UPDATE_TRACK: 'Alterar track',
    REORDER_TRACKS: 'Reordenar tracks',
    ADD_ITEM: 'Adicionar clip',
    REMOVE_ITEMS: 'Remover clips',
    UPDATE_ITEMS: 'Alterar clips',
    MOVE_ITEMS: 'Mover clips',
    TRIM_ITEM: 'Ajustar clip',
    SPLIT_ITEM: 'Dividir clip',
    DUPLICATE_ITEMS: 'Duplicar clips',
    DELETE_RANGE: 'Remover trecho',
    LIFT_RANGE: 'Extrair trecho',
    INSERT_GAP: 'Inserir espaço',
    SET_SPEED: 'Alterar velocidade',
    SET_TRANSFORM: 'Transformar',
    SET_CROP: 'Recortar',
    SET_VOLUME: 'Alterar volume',
    SET_KEYFRAMES: 'Definir keyframes',
    ADD_KEYFRAME: 'Adicionar keyframe',
    REMOVE_KEYFRAMES: 'Remover keyframes',
    UPDATE_KEYFRAME: 'Alterar keyframe',
    ADD_EFFECT: 'Adicionar efeito',
    REMOVE_EFFECT: 'Remover efeito',
    UPDATE_EFFECT: 'Alterar efeito',
    ADD_TEXT: 'Adicionar texto',
    UPDATE_TEXT: 'Editar texto',
    ADD_CAPTIONS: 'Gerar legendas',
    UPDATE_CAPTION_STYLE: 'Estilo de legenda',
    SET_CAPTION_WORDS: 'Editar legenda',
    ADD_MARKER: 'Adicionar marcador',
    REMOVE_MARKER: 'Remover marcador',
    UPDATE_MARKER: 'Alterar marcador',
    GROUP_ITEMS: 'Agrupar',
    UNGROUP_ITEMS: 'Desagrupar',
    SET_SEQUENCE_SETTINGS: 'Configurações da sequência',
    RESTORE_TRACKS: 'Restaurar',
    BATCH: 'Edição em lote',
};
export function commandLabel(command) {
    if (command.reason)
        return command.reason;
    if (command.type === 'BATCH') {
        const n = command.payload.commands.length;
        return command.source === 'AI' ? `IA: ${n} alterações` : `${n} alterações`;
    }
    return LABELS[command.type] ?? command.type;
}
//# sourceMappingURL=history.js.map